import axiosInstance from "@API/axios";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { setSnackbar } from "@Redux/snackBarSlice";

const usePostItem = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const postItem = (
    url,
    item,
    postCallback,
    successMessage,
    errorMessage,
    showSnackbar = true,
    method = "post"
  ) => {
    setLoading(true);
    return axiosInstance[method.toLowerCase()](url, item) // Dynamically call .post or .put
      .then((response) => {
        setLoading(false);
        if (successMessage) {
          dispatch(
            setSnackbar({
              open: showSnackbar,
              message: successMessage,
              error: false,
            })
          );
        }
        postCallback(response.data, item);
        return response.data;
      })
      .catch((error) => {
        const responseData = error.response?.data;
        const message =
          errorMessage ||
          (typeof responseData === "object" && responseData !== null
            ? responseData.details || responseData.message
            : responseData) ||
          "Internal Server Error.";

        dispatch(
          setSnackbar({
            open: true,
            message,
            error: true,
          })
        );
        setLoading(false);
        return false;
      });
  };

  return { loading, postItem };
};

export default usePostItem;
